import React from "react";

export default function AppLoader({
  message = "Loading...",
  title = "Restoring Workspace",
  variant = "fullscreen",
  className = "",
}) {
  const wrapperClass = [
    "auth-bootstrap-screen",
    variant === "compact" ? "auth-bootstrap-screen-compact" : "",
    variant === "inline" ? "auth-bootstrap-screen-inline" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClass} role="status" aria-live="polite">
      <div className="auth-bootstrap-mark">
        <div className="auth-bootstrap-orbit auth-bootstrap-orbit-a" />
        <div className="auth-bootstrap-orbit auth-bootstrap-orbit-b" />
        <div className="auth-bootstrap-core">
          <span>K</span>
        </div>
      </div>
      <div className="auth-bootstrap-copy">
        <div className="auth-bootstrap-brand">
          <span className="auth-bootstrap-brand-kicker">KorvRFM</span>
          <strong>{title}</strong>
        </div>
        <p>{message}</p>
        <div className="auth-bootstrap-signal" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}
